import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"logout-button",on:{"click":_vm.handleLogout}},[_c(VIcon,[_vm._v("mdi-logout")]),_c('span',[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }